import { useCallback, useState } from 'react';

type Props = {
  onOpen?: () => void;
  onClose?: () => void;
};

type OpenClose = {
  isOpen: boolean;
  handleOpen: () => void;
  handleClose: () => void;
};

const useOpenClose = (initial = false, params: Props = {}): OpenClose => {
  const { onOpen, onClose } = params;
  const [isOpen, setIsOpen] = useState(initial);

  const handleClose = useCallback(() => {
    setIsOpen(false);
    onClose?.();
  }, [onClose]);

  const handleOpen = useCallback(() => {
    setIsOpen(true);
    onOpen?.();
  }, [onOpen]);

  return { isOpen, handleOpen, handleClose };
};

export default useOpenClose;
